import { EmptyState, NotFoundIcon } from '@lmc/ui-kit'
import { TabBarWrapper } from 'components/generic/TabBar/TabBarWrapper'
import { get } from 'lodash'
import { Component } from 'react'
import { isBrowser, isTablet } from 'react-device-detect'
import { connect } from 'react-redux'
import { Link, Navigate, Outlet } from 'react-router-dom'
import Selectors from 'selectors'
import { withRouter } from '../../withRouter'

const isDesktop = isBrowser || isTablet

export class OrganisationScreen extends Component {
  hasRolePermissions = () =>
    this.props.hasAccess(
      ['carehome-admin'],
      [
        {
          i: 'view',
          this: 'User'
        }
      ]
    )

  renderTabs = () => {
    const { location, role, features, hasRota } = this.props

    const isSeniorCarer = this.props.role === 'senior-carer'

    const deviceAccessControlGranted =
      features?.features?.deviceAccessControl?.granted

    const tabs = [
      { url: 'list', label: 'Team Members List', octicon: 'organization' },
      {
        url: 'shift-passwords',
        label: 'Shift Passwords',
        octicon: 'key',
        disabledByPermission: isSeniorCarer
      },
      {
        url: 'documents',
        label: 'Documents',
        octicon: 'file',
        disabledByPermission: isSeniorCarer
      },
      ...(deviceAccessControlGranted
        ? [
            {
              url: 'devices',
              label: 'Devices',
              disabledByPermission: isSeniorCarer
            }
          ]
        : []),
      ...(hasRota
        ? [
            {
              url: 'all-absences',
              label: 'All Absences'
            }
          ]
        : [])
    ]

    if (!isDesktop || ['group-admin', 'group-manager'].includes(role)) {
      return null
    }

    return (
      <div style={styles.navbar} data-testid="organisation-navigation">
        <TabBarWrapper
          items={tabs}
          location={location}
          resourceUrl="organisation"
          testId="organisation-tab-bar"
        />
      </div>
    )
  }

  render() {
    const { role, router, permissionsLoading } = this.props

    if (permissionsLoading) return null

    const hasRolePermission = this.hasRolePermissions()

    if (
      ![
        'carehome-admin',
        'group-admin',
        'group-manager',
        ...(hasRolePermission ? ['senior-carer'] : [])
      ].includes(role)
    ) {
      return (
        <EmptyState
          title="We cant find what you're looking for... Error 404"
          description="Don't worry, try refreshing the page and if the problem persists contact support."
          icon={<NotFoundIcon />}
          testId="organisation-404-error"
        >
          <Link to="/" data-testid="organisation-go-back-home">
            Go back home
          </Link>
        </EmptyState>
      )
    }

    return (
      <div data-testid="organisation-screen">
        {this.renderTabs()}
        {router.location.pathname === '/organisation' ? (
          <Navigate to="team" />
        ) : (
          <Outlet />
        )}
      </div>
    )
  }
}

const styles = {
  navbar: {
    zIndex: 2
  }
}

const mapStateToProps = (state) => ({
  role: get(state, 'global.user.role'),
  isDeviceAccessControl: get(state, 'global.home.deviceAccessControl'),
  features: state.global.home,
  permissionsLoading: get(state, 'global.permissionsLoading', true),
  hasAccess: (roles, abilities) =>
    Selectors.checkRoleAccess(state, { roles, abilities })
})

export default connect(mapStateToProps)(withRouter(OrganisationScreen))
